import Microphone from './Microphone';

export default Microphone;
